import {createSelector} from '@ngrx/store';
import { InternalUserRole } from 'libs/tm-common/src/lib/models/user.model';
import {selectAuthState} from './auth.reducer';

export const selectIsAdmin = createSelector(
	selectAuthState,
	auth => auth.isAdmin
);

export const selectIsSuperAdmin = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "1" && auth.user.roles.includes(InternalUserRole.ADMIN)
);

export const selectInternalUserRoles = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "1" ? auth.user.roles : []
);

export const selectIsSignedIn = createSelector(
	selectAuthState,
	auth => auth.signedIn
);

export const selectIsSignedOut = createSelector(
	selectIsSignedIn,
	signedIn => !signedIn
);

export const selectCustomerSession = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "0" ? auth.user : null
);

export const selectAdminSession = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "1" ? auth.user : null
);

export const selectDisplayName = createSelector(
	selectAuthState,
	auth => auth && auth.user ?  auth.user.displayName : ''
);

export const selectAdminUsername = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "1" ? auth.user.adminData.username : ''
)

export const selectWmsId = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "0" ? auth.user.wmsId : ''
);

export const selectIsFunctionALCertified = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "0" && auth.user.isFunctionALCertified
);

export const selectIsPeekRetainerVisible = createSelector(
	selectAuthState,
	auth => auth?.user?.tm_admin === "0" && auth.user.isPeekRetainerVisible
);
